import React, { useEffect } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import Button from 'src/components/button';
import SlideInModal from 'src/components/slideInModal';
import useFetch from 'src/hooks/useFetch';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
interface IProps {
  children?: React.ReactNode;
  categoryId?: string;
}
const EditCategory: React.FC<IProps> = ({ children, categoryId }) => {
  const [showModal, setShowModal] = React.useState(true);
  const [categoryItems, setCategoryItems] = React.useState([]);

  const handleModal = () => {
    setShowModal(!showModal);
  };
  const userInfo: any = localStorage.getItem('userInfo');
  const bussinessID: any = JSON.parse(userInfo).businessInfo.id;

  const {
    data: itemsData,
    fetchData,
    isLoading,
    errorText,
  } = useFetch('/categories/all/' + bussinessID);

  const onDragEnd = (result: any) => {
    if (!result.destination) return;

    const items: any = Array.from(categoryItems);
    const reorderedItem: any = items.splice(result.source.index, 1)[0];
    items.splice(result.destination.index, 0, reorderedItem);

    setCategoryItems(items);

    const payload = {
      categoryId: categoryId,
      itemId: reorderedItem?.id,
      newOrder: result.destination.index + 1,
    };

    Service.post('/categories/item/change/order', payload)
      .then(() => {
        setCategoryItems(items);
      })
      .catch((error) => {
        console.error('Error updating category order:', error);
        toastAlert('error', 'Error updating category order');
        setCategoryItems(categoryItems);
      });
  };

  useEffect(() => {
    itemsData?.categoriesWithItems?.map((category: any, index: number) => {
      category?.id === categoryId && setCategoryItems(category?.items);
    });
  }, [itemsData]);

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="w-[300px] xl:w-[388px] rounded-xl border border-border-color-dark pb-6">
        {children}
        {showModal ? (
          <SlideInModal
            showModal={showModal}
            title={'Items List'}
            onClick={handleModal}
            className="bg-pure-white z-[9999]"
          >
            <Droppable droppableId="categoryItems">
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="flex flex-col  py-1"
                >
                  {categoryItems?.map((item: any, index: number) => (
                    <Draggable
                      key={item.id}
                      draggableId={item.id.toString()}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="transition-[transform 0.2s cubic-bezier(0.2, 0, 0, 1)!important] w-full px-6 py-2.5 mb-2 rounded-xl border border-border-color-dark justify-start items-center gap-2 flex"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.5 3.74994C6.5 3.89828 6.45601 4.04328 6.3736 4.16662C6.29119 4.28995 6.17406 4.38608 6.03701 4.44285C5.89997 4.49961 5.74917 4.51447 5.60368 4.48553C5.4582 4.45659 5.32456 4.38516 5.21967 4.28027C5.11478 4.17538 5.04335 4.04174 5.01441 3.89626C4.98547 3.75077 5.00032 3.59997 5.05709 3.46293C5.11386 3.32588 5.20999 3.20875 5.33332 3.12634C5.45666 3.04393 5.60166 2.99994 5.75 2.99994C5.94891 2.99994 6.13968 3.07896 6.28033 3.21961C6.42098 3.36026 6.5 3.55103 6.5 3.74994ZM10.25 4.49994C10.3983 4.49994 10.5433 4.45595 10.6667 4.37354C10.79 4.29113 10.8861 4.174 10.9429 4.03695C10.9997 3.89991 11.0145 3.74911 10.9856 3.60362C10.9567 3.45814 10.8852 3.3245 10.7803 3.21961C10.6754 3.11472 10.5418 3.04329 10.3963 3.01435C10.2508 2.98541 10.1 3.00026 9.96299 3.05703C9.82594 3.1138 9.70881 3.20992 9.6264 3.33326C9.54399 3.4566 9.5 3.6016 9.5 3.74994C9.5 3.94885 9.57902 4.13962 9.71967 4.28027C9.86032 4.42092 10.0511 4.49994 10.25 4.49994ZM5.75 7.24994C5.60166 7.24994 5.45666 7.29393 5.33332 7.37634C5.20999 7.45875 5.11386 7.57588 5.05709 7.71293C5.00032 7.84997 4.98547 8.00077 5.01441 8.14626C5.04335 8.29174 5.11478 8.42538 5.21967 8.53027C5.32456 8.63516 5.4582 8.70659 5.60368 8.73553C5.74917 8.76447 5.89997 8.74961 6.03701 8.69285C6.17406 8.63608 6.29119 8.53995 6.3736 8.41662C6.45601 8.29328 6.5 8.14828 6.5 7.99994C6.5 7.80103 6.42098 7.61026 6.28033 7.46961C6.13968 7.32896 5.94891 7.24994 5.75 7.24994ZM10.25 7.24994C10.1017 7.24994 9.95666 7.29393 9.83332 7.37634C9.70999 7.45875 9.61386 7.57588 9.55709 7.71293C9.50033 7.84997 9.48547 8.00077 9.51441 8.14626C9.54335 8.29174 9.61478 8.42538 9.71967 8.53027C9.82456 8.63516 9.9582 8.70659 10.1037 8.73553C10.2492 8.76447 10.4 8.74961 10.537 8.69285C10.6741 8.63608 10.7912 8.53995 10.8736 8.41662C10.956 8.29328 11 8.14828 11 7.99994C11 7.80103 10.921 7.61026 10.7803 7.46961C10.6397 7.32896 10.4489 7.24994 10.25 7.24994ZM5.75 11.4999C5.60166 11.4999 5.45666 11.5439 5.33332 11.6263C5.20999 11.7087 5.11386 11.8259 5.05709 11.9629C5.00032 12.1 4.98547 12.2508 5.01441 12.3963C5.04335 12.5417 5.11478 12.6754 5.21967 12.7803C5.32456 12.8852 5.4582 12.9566 5.60368 12.9855C5.74917 13.0145 5.89997 12.9996 6.03701 12.9428C6.17406 12.8861 6.29119 12.79 6.3736 12.6666C6.45601 12.5433 6.5 12.3983 6.5 12.2499C6.5 12.051 6.42098 11.8603 6.28033 11.7196C6.13968 11.579 5.94891 11.4999 5.75 11.4999ZM10.25 11.4999C10.1017 11.4999 9.95666 11.5439 9.83332 11.6263C9.70999 11.7087 9.61386 11.8259 9.55709 11.9629C9.50033 12.1 9.48547 12.2508 9.51441 12.3963C9.54335 12.5417 9.61478 12.6754 9.71967 12.7803C9.82456 12.8852 9.9582 12.9566 10.1037 12.9855C10.2492 13.0145 10.4 12.9996 10.537 12.9428C10.6741 12.8861 10.7912 12.79 10.8736 12.6666C10.956 12.5433 11 12.3983 11 12.2499C11 12.051 10.921 11.8603 10.7803 11.7196C10.6397 11.579 10.4489 11.4999 10.25 11.4999Z"
                              fill="#CACFE3"
                            />
                          </svg>
                          <div className="flex gap-4">
                            <div
                              className={`shadow-xl w-[30px] h-[30px] ${
                                item.shape === 'square' || item?.image
                                  ? 'rounded bg-cover bg-center'
                                  : 'rounded-full'
                              }`}
                              style={{
                                backgroundImage: `url('${item.image}')`,
                              }}
                            ></div>

                            {item.name}
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                </div>
              )}
            </Droppable>
          </SlideInModal>
        ) : (
          <Button
            text="Items List"
            onClick={handleModal}
            className="absolute top-0 right-0"
          />
        )}
      </div>
    </DragDropContext>
  );
};

export default EditCategory;
